import React, { useEffect, useState, useMemo } from 'react';
import $ from 'jquery';
import 'datatables.net';
import Swal from "sweetalert2";

import "react-loading-skeleton/dist/skeleton.css";
import Select from "react-select";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

const JenisAbsensi = () => {
  // 📌 Options
  const kategoriOptions = useMemo(() => [
    { value: 'sekali', label: 'Sekali' },
    { value: 'harian', label: 'Harian' },
    { value: 'tanggal_tertentu', label: 'Tanggal Tertentu' },
    { value: 'fleksibel', label: 'Bebas' },
  ], []);

  const groupabsensi = useMemo(() => [
    { value: 'dirisendiri', label: 'Diri Sendiri' },
    { value: 'oranglain', label: 'Orang Lain' },
    { value: 'diri sendiri dan orang lain', label: 'Diri Sendiri dan Orang Lain' },
  ], []);

  const statusaktif = [
    { value: '1', label: 'Aktif' },
    { value: '0', label: 'Tidak Aktif' }
  ];

  // 📌 State kalender
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedRanges, setSelectedRanges] = useState([]);
  const [tempStart, setTempStart] = useState(null);
  const [selectedDates, setSelectedDates] = useState([]);

  // Toggle multi tanggal
  const handleMultiDateClick = (date) => {
    const exists = selectedDates.find(d => d.toDateString() === date.toDateString());
    if (exists) {
      setSelectedDates(selectedDates.filter(d => d.toDateString() !== date.toDateString()));
    } else {
      setSelectedDates([...selectedDates, date]);
    }
  };

  const handleRangeClick = (date) => {
    const existingRangeIndex = selectedRanges.findIndex(r => date >= r.start && date <= r.end);
    if (existingRangeIndex !== -1) {
      const newRanges = [...selectedRanges];
      newRanges.splice(existingRangeIndex, 1);
      setSelectedRanges(newRanges);
      setTempStart(null);
      return;
    }

    if (!tempStart) {
      setTempStart(date);
    } else {
      const start = tempStart < date ? tempStart : date;
      const end = tempStart < date ? date : tempStart;
      setSelectedRanges([...selectedRanges, { start, end }]);
      setTempStart(null);
    }
  };

  const getTileClassForRange = ({ date }) => {
    for (let r of selectedRanges) {
      if (date >= r.start && date <= r.end) return "selected-range";
    }
    if (tempStart && date.getTime() === tempStart.getTime()) return "selected-range";
    return null;
  };

  // 📌 State form absensi
  const [formData, setFormData] = useState({
    nama: "",
    kategori: "",
    deskripsi: "",
    aktif: 1,
  });
  const [isEditing, setIsEditing] = useState(false);

  // 📌 DataTable init
  useEffect(() => {
    if ($.fn.dataTable.isDataTable('.table-data')) {
      $('.table-data').DataTable().destroy();
    }

    $('.table-data').DataTable({
      ajax: {
        url: `${process.env.REACT_APP_BASE_URL}apiuser/getjenisabsensi`,
        type: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        },
        dataSrc: (json) => json.data || []
      },
      columns: [
        { data: null, render: (data, type, row, meta) => meta.row + 1 },
        { data: null, render: (data) => `<a href="/admin/absensi/viewmasterabsensi?id=${data.id}"><b>${data.nama}</b></a>` },
        { data: "kategori_presensi" },
        { data: "deskripsi" },
        {
          data: null, render: (data, type, row) => `
            <a href="/admin/absensi/viewmasterabsensi?id=${row.id}">
              <i class="ti ti-manual-gearbox f-20"></i>
            </a>
            <a data-bs-toggle="modal" data-bs-target="#ujianModal" class="edit-btn avtar avtar-xs mx-1 btn-link-secondary" data-row='${JSON.stringify(row)}'>
              <i class="ti ti-edit f-20"></i>
            </a>
            <a href="#" class="delete-btn avtar avtar-xs mx-1 btn-link-danger" data-id="${row.id}">
              <i class="ti ti-trash f-20"></i>
            </a>
          `
        },
      ],
      destroy: true,
      language: {
        search: "",
        emptyTable: "Belum memiliki data",
        loadingRecords: "Loading....",
        zeroRecords: "Belum memiliki data"
      },
    });

    return () => {
      if ($.fn.dataTable.isDataTable('.table-data')) {
        $('.table-data').DataTable().destroy();
      }
    };
  }, [kategoriOptions]);

  // 📌 Event tombol edit & delete
  $(document).off("click", ".edit-btn").on("click", ".edit-btn", function () {
    let rowData = $(this).data("row");
    if (rowData) handleEdit(rowData);
  });

  $(document).on("click", ".delete-btn", function (e) {
    e.preventDefault();
    let id = $(this).data("id");

    Swal.fire({
      title: "Apakah Anda yakin?",
      text: "Data akan dihapus secara permanen!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Ya, hapus!",
      cancelButtonText: "Batal"
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/hapusujian`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem('authToken')}`
          },
          body: JSON.stringify({ id_ujian: id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.success) {
              Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
              $('.table-data').DataTable().ajax.reload();
            } else {
              Swal.fire("Gagal!", data.message, "error");
            }
          })
          .catch(() => {
            Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
          });
      }
    });
  });

  // 📌 Handlers form
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleEdit = (ujian) => {
    setIsEditing(true);
    setFormData(ujian);
  };

  const handleNew = () => {
    setIsEditing(false);
    setFormData({
      id: "",
      nama: "",
      kategori: kategoriOptions[0].value,
      deskripsi: "",
      aktif: statusaktif[0].value
    });
    setSelectedDate(null);
    setSelectedRanges([]);
    setTempStart(null);
    setSelectedDates([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let tanggalAbsensi = null;
    if (formData.kategori === "sekali") {
      tanggalAbsensi = selectedDate;
    } else if (formData.kategori === "harian") {
      tanggalAbsensi = selectedRanges;
    } else {
      tanggalAbsensi = selectedDates;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/absensi/inputmasterabsensi`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        },
        body: JSON.stringify({ ...formData, tanggalAbsensi }),
      });

      const result = await response.json();
      Swal.fire("Berhasil!", result.message, "success").then(() => {
        $('.table-data').DataTable().ajax.reload(null, false);
      });
    } catch (error) {
      Swal.fire("Error!", error.message || 'Something went wrong', "error");
    }
  };

  const handleChangeKategori = (opt) => {
    if (!opt) return;
    setFormData((prev) => ({ ...prev, kategori: opt.value }));
    setSelectedDate(null);
    setSelectedRanges([]);
    setTempStart(null);
    setSelectedDates([]);
  };

  const handleChangeKGroup = (opt) => {
    if (!opt) return;
    setFormData((prev) => ({ ...prev, group: opt.value }));
  };

  const handleChangeAktif = (opt) => {
    if (!opt) return;
    setFormData((prev) => ({ ...prev, aktif: opt.value }));
  };


    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="col-xl-12 col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className='row mb-3 align-items-center'>
                                        <div className="col">
                                            <small className="text-muted">Refrensi</small><h3>Jadwal Absensi</h3>
                                        </div>
                                        <div className='col-auto'>
                                            <button data-bs-toggle="modal" data-bs-target="#ujianModal" onClick={handleNew} type="button" className="btn btn-primary d-inline-flex">
                                                <i className="ti ti-plus me-1"></i> Data Baru
                                            </button>
                                        </div>
                                    </div>
                                    <hr />
                                    <table className="table table-data table-hover datatable-table">
                                        <thead>
                                            <tr>
                                                <th width="50">#</th>
                                                <th>Nama</th>
                                                <th>Kategori</th>
                                                <th>Deskripsi</th>
                                                <th width="50"><center>Action</center></th>
                                            </tr>
                                        </thead>
                                        <tbody></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal */}
            <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <form onSubmit={handleSubmit} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{isEditing ? "Edit Master Absensi" : "Tambah Master Absensi"}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className='col-md-6'>
                            <div className="mb-3">
                                <b className="form-label">Nama Kegiatan</b>
                                <input name='nama' className="form-control" type="text" value={formData.nama} onChange={handleChange} />
                            </div>
                            <div className="mb-3">
                                <b className="form-label">Kategori</b>
                                <Select
                                    options={kategoriOptions}
                                    value={kategoriOptions.find(o => o.value === formData.kategori) || null}
                                    onChange={handleChangeKategori}
                                    placeholder="Pilih Kategori..."
                                />
                            </div>

                            {/* Kalender kategori */}
                            {formData.kategori === "sekali" && (
                                <div className="mb-3">
                                    <b className="form-label">Pilih Tanggal</b>
                                    <input name='nama' className="form-control" type="date" value={formData.nama} onChange={handleChange} />
                                </div>
                            )}

                            {formData.kategori === "harian" && (
                                <div className="mb-3">
                                    <b className="form-label">Atur Sesuai Hari</b>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                             <label className="form-label">Tanggal Mulai</label>
                                            <input name='nama' className="form-control" type="date" value={formData.nama} onChange={handleChange} />

                                            </div>
                                              <div className='col-md-6'>
                                                 <b className="form-label">Tanggal Selesai</b>
                                                <input name='nama' className="form-control" type="date" value={formData.nama} onChange={handleChange} />

                                            </div>
                                            <div className='col-md-12'>
                                                <table className="table">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Hari</th>
                                                <th>Waktu Mulai</th>
                                                <th>Waktu Selesai</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {[
                                                "Senin",
                                                "Selasa",
                                                "Rabu",
                                                "Kamis",
                                                "Jumat",
                                                "Sabtu",
                                                "Minggu",
                                            ].map((hari, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{hari}</td>
                                                    <td>
                                                        <input
                                                            type="time"
                                                            className="form-control"
                                                            name={`waktuMulai_${hari}`}
                                                            value={formData.harian?.[hari]?.mulai || ""}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    harian: {
                                                                        ...prev.harian,
                                                                        [hari]: {
                                                                            ...prev.harian?.[hari],
                                                                            mulai: e.target.value,
                                                                        },
                                                                    },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="time"
                                                            className="form-control"
                                                            name={`waktuSelesai_${hari}`}
                                                            value={formData.harian?.[hari]?.selesai || ""}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    harian: {
                                                                        ...prev.harian,
                                                                        [hari]: {
                                                                            ...prev.harian?.[hari],
                                                                            selesai: e.target.value,
                                                                        },
                                                                    },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                            </div>
                                    </div>
                                    
                                </div>
                            )}



                            {formData.kategori === "tanggal_tertentu" && (
                                <div className="mb-3">
                                    <label className="form-label">Pilih Beberapa Tanggal</label>
                                    <Calendar
                                        style={{ width: "100%" }}
                                        onClickDay={handleMultiDateClick}
                                        tileClassName={({ date }) =>
                                            selectedDates.find(d => d.toDateString() === date.toDateString())
                                                ? "selected-date"
                                                : null
                                        }
                                    />
                                    {selectedDates.length > 0 && (
                                        <ul>
                                            {selectedDates.map((d, i) => (
                                                <li key={i}>{d.toLocaleDateString()}</li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            )}

                            {formData.kategori === "fleksibel" && (
                                <div className="mb-3">
                                    <label className="form-label">Bisa Kapan Saja</label>

                                </div>
                            )}
                            <div className="mb-3">
                                <label className="form-label"><b>Pengaturan</b></label>
                                <div class="form-check mb-3">
                                    <input class="form-check-input" type="checkbox" value="" id="Selfe" checked />
                                    <label class="form-check-label" for="Selfe">Wahib Selfe</label>
                                </div>
                                <div class="form-check mb-3">
                                    <input class="form-check-input" type="checkbox" value="" id="Lokasi" checked />
                                    <label class="form-check-label" for="Lokasi">Lokasi</label>
                                </div>
                                <div class="form-check mb-3">
                                    <input class="form-check-input" type="checkbox" value="" id="Kegiatan" />
                                    <label class="form-check-label" for="Kegiatan">Foto Kegiatan</label>
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="form-label"><b>Deskripsi</b></label>
                                <textarea name='deskripsi' className="form-control" value={formData.deskripsi} onChange={handleChange} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Aktif</label>
                                <Select
                                    options={statusaktif}
                                    value={statusaktif.find(o => o.value.toString() === formData.aktif.toString()) || null}
                                    onChange={handleChangeAktif}
                                    placeholder="Pilih Status..."
                                />
                            </div>
                        </div>
                         <div className='col-md-6'>
                            <div className='row'>
                                <div className='col-md-12'>
                                     <div className="mb-3">
                                <label className="form-label">Pilih Group</label>
                                <Select
                                    options={groupabsensi}
                                    value={groupabsensi.find(o => o.value === formData.group) || null}
                                    onChange={handleChangeKGroup}
                                    placeholder="Pilih Group..."
                                />
                            </div>

                                 </div>
                                 <div className='col-md-6'>
<div className="mb-3">
                                    <label className="form-label">Pilih Target</label>
                                    </div>
                                     <div className="mb-3">
                                    <div class="btn-group" role="group" aria-label="Basic example">
    <button type="button" class="btn btn-primary">Peserta Didik</button> 
    <button type="button" class="btn btn-primary">Pendidik</button> 
    <button type="button" class="btn btn-primary">Kependidikan</button>
</div>
                                </div>
                                <table className="table">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Nama</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {[
                                                "Senin",
                                                "Selasa",
                                                "Rabu",
                                                "Kamis",
                                                "Jumat",
                                                "Sabtu",
                                                "Minggu",
                                            ].map((hari, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{hari}</td>
                                                    
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                 </div>
                                  {(formData.group === "oranglain" || formData.group === "diri sendiri dan orang lain") && (
                                  <div className='col-md-6'>
                                    <div className="mb-3">
                                    <label className="form-label">Pilih Target</label>
                                    </div>
                                     <div className="mb-3">
                                    <div class="btn-group" role="group" aria-label="Basic example">
    <button type="button" class="btn btn-primary">Peserta Didik</button> 
    <button type="button" class="btn btn-primary">Pendidik</button> 
    <button type="button" class="btn btn-primary">Kependidikan</button>
</div>
                                </div>
                                <table className="table">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Nama</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {[
                                                "Senin",
                                                "Selasa",
                                                "Rabu",
                                                "Kamis",
                                                "Jumat",
                                                "Sabtu",
                                                "Minggu",
                                            ].map((hari, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{hari}</td>
                                                    
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                 </div>
    )};

                            </div>
                         </div>
                        
                        </div>
                        
                        </div><div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Batal</button>
                            <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">
                                {isEditing ? "Update" : "Simpan"}
                            </button>
                        </div>
                    </form>
                    
                </div>
            </div>

            {/* style untuk highlight multi tanggal / range */}
            <style>
                {`
          .selected-date, .selected-range {
            background: #007bff !important;
            color: white !important;
            border-radius: 5px;
          }
        `}
            </style>
        </div>
    );
};

export default JenisAbsensi;
